import { render, staticRenderFns } from "./ImsInventoryErrorList.vue?vue&type=template&id=d638678a&"
import script from "./ImsInventoryErrorList.vue?vue&type=script&lang=js&"
export * from "./ImsInventoryErrorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports